import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Stepper } from '@node-space/storybook-components/dist/Stepper'
import { Container } from 'components/Container'
import { SelfCategorisationStepKeys, selfCategorisationStepList } from 'pages/Finprom/constants'
import { SelfCategorisationStepKey } from 'pages/Finprom/types'
import { VerificationHeader } from 'pages/Verification/_components/VerificationHeader'
import { scrollToTop } from 'utils/utils'
import { SelfCategorisationStep } from './SelfCategorisationStep'

export const SelfCategorisation = () => {
  const { t } = useTranslation()
  const [activeStep, setActiveStep] = useState<SelfCategorisationStepKey>(
    selfCategorisationStepList[0]
  )

  useEffect(() => scrollToTop(), [activeStep])

  return (
    <Container>
      <VerificationHeader header={t('finprom.steps.selfCategorisation')} />
      <Stepper<SelfCategorisationStepKey>
        stepKeys={selfCategorisationStepList}
        activeStepKey={activeStep}
        onBack={stepKey => setActiveStep(stepKey)}
      />
      <SelfCategorisationStep
        activeStep={activeStep}
        onContinue={() => setActiveStep(SelfCategorisationStepKeys.CONFIRM_CATEGORY)}
      />
    </Container>
  )
}
